import { HelloJSServiceDef } from 'hellojs';

let MsaIntConfig: HelloJSServiceDef = {
    name: 'Windows live',

    oauth: {
        version: 2,
        auth: 'https://login.live-int.com/oauth20_authorize.srf',
        grant: 'https://login.live-int.com/oauth20_token.srf',
    },

    // Refresh the access_token once expired
    refresh: false,

    logout: function () {
        return 'https://login.live-int.com/oauth20_logout.srf?ts=' + new Date().getTime();
    },

    // Authorization scopes
    scope: {
        basic: '',
    },

    // API base URL
    base: 'https://apis.live-int.net/v5.0/',
};
export default MsaIntConfig;
